import { render, staticRenderFns } from "./TermsConsentimento.vue?vue&type=template&id=5e45efaa&scoped=true"
import script from "./TermsConsentimento.vue?vue&type=script&lang=js"
export * from "./TermsConsentimento.vue?vue&type=script&lang=js"
import style0 from "./TermsConsentimento.vue?vue&type=style&index=0&id=5e45efaa&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e45efaa",
  null
  
)

export default component.exports